import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    // モーダル外をクリックで閉じる処理
    window.addEventListener('click', this.handleWindowClick)
  }

  disconnect() {
    window.removeEventListener('click', this.handleWindowClick)
  }

  open() {
    document.getElementById('vr-modal').style.display = 'block'
  }

  close() {
    document.getElementById('vr-modal').style.display = 'none'
  }

  handleWindowClick = (event) => {
    if (event.target === document.getElementById('vr-modal')) {
      this.close()
    }
  }
}